import { globalQueries } from 'src/api/queries';

export const mediaQueryKey = {
  signedUrls: (id: string, ...args: any[]) => [globalQueries.mediaSignedUrl, id, ...(args ?? [])],
} as const;
